import React from 'react';
import { Navbar } from './Navbar';
import './ComingSoon.css';

export const ComingSoon = ({ onRestart, onSignup, isComplete = false, user, onSignInClick }) => {
  return (
    <div className="coming-soon base-background">
      <Navbar currentUser={user} onSignInClick={onSignInClick} />
      
      <div className="coming-soon-content">
        <h1 className="coming-soon-title">Coming Soon!</h1>
        
        <div className="coming-soon-message">
          {isComplete ? (
            <>
              <p className="message-text">
                Thank you for signing up! 🎉
              </p>
              
              <p className="message-text">
                Your profile has been saved and you're all set!
              </p>
              
              <p className="message-text">
                We'll notify you when new features are available.
              </p>
            </>
          ) : (
            <>
              <p className="message-text">
                We are thrilled to know of your interest in learning more about yourself!
              </p>
              
              <p className="message-text">
                More features of our app will be out soon!
              </p>
              
              <p className="message-text">
                Please visit us later to continue your MindQuest!
              </p>
            </>
          )}
        </div>
        
        <div className="coming-soon-actions">
          {!isComplete ? (
            <>
              {!user && (
                <button 
                  onClick={onSignup}
                  className="signup-complete-btn"
                >
                  Sign Up to Resume Your Journey
                </button>
              )}
              
              <button 
                onClick={onRestart}
                className={user ? "signup-complete-btn" : "restart-btn"}
              >
                Take Test Again
              </button>
            </>
          ) : (
            <>
              <button 
                onClick={onRestart}
                className="signup-complete-btn"
              >
                Take Test Again
              </button>
              
              <button 
                onClick={onSignup}
                className="restart-btn"
              >
                Update Profile
              </button>
            </>
          )}
        </div>
        
        <div className="feature-preview">
          <h3 className="preview-title">Coming Features:</h3>
          <ul className="feature-list">
            <li>Detailed personality analysis reports</li>
            <li>Personalized learning recommendations</li>
            <li>Progress tracking over time</li>
            <li>Advanced cognitive assessments</li>
            <li>Social sharing and comparisons</li>
          </ul>
        </div>
      </div>

      <div className="footer-brand">
        <span>youdontknowyou.com</span>
      </div>
    </div>
  );
};